import { Components, Theme } from "@mui/material";

export const DialogStyle = (theme: Theme): Pick<Components, "MuiDialog"> => {
  return {
    MuiDialog: {
      styleOverrides: {
        root: {
          ".MuiBackdrop-root": {
            background: "rgba(0, 0, 0, 0.2)",
          },
        },
        paper: {
          backgroundColor: "rgb(0 0 0 / 90%)",
          padding: "16px",
        },
      },
    },
  };
};
